import React from "react";

export const Logo = ({ className = "", dark = false }) => {
  return (
    <a
      href="/"
      data-testid="nav-logo"
      className={`inline-flex items-center gap-2.5 group ${className}`}
    >
      <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-md gold-bg shadow-sm">
        <svg
          viewBox="0 0 24 24"
          className="h-5 w-5 text-white"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 12h3l2-7 4 14 2-7h7" />
        </svg>
      </span>
      <span className={`font-semibold tracking-tight text-lg ${dark ? "text-white" : "text-foreground"}`}>
        SmartPeptides
        <span className="gold-text">.ai</span>
      </span>
    </a>
  );
};
